export default "__VITE_ASSET__6b237519__"